import { BlogStatusEnum } from '@ztechapps/common.contract'

// Each `color` is a CSS custom property defined in `libs/blog/webui/src/BlogStatus.scss`.
// It resolves only in a browser that has loaded that stylesheet; elsewhere it is literal text.
export const BlogStatus = {
  active: {
    value: BlogStatusEnum.Active,
    description: 'Active',
    color: 'var(--blog-status-active)',
  },
  inActive: {
    value: BlogStatusEnum.InActive,
    description: 'In Active',
    color: 'var(--blog-status-inactive)',
  },
  draft: {
    value: BlogStatusEnum.Draft,
    description: 'Draft',
    color: 'var(--blog-status-draft)',
  },
  internal: {
    value: BlogStatusEnum.Internal,
    description: 'Internal',
    color: 'var(--blog-status-internal)',
  },
}
